/**
 * Inventory Orders               - Inventory Orders List
 * Inventory Order                - Inventory Order by Location ID
 * Location Order Approve         - Approve and generate order for Location
 * Location Order Delete          - Delete order for Location
 * Location Order Product Edit    - Edit requested Case Qty for Product
 * Location Order Product Approve - Submit Product for Location order
 * Location Order Product Remove  - Remove Product from Location order
 *
 */
export const RESOURCES = {
    'InventoryOrder': {
        GET_LIST: function (params) {
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Inventory Orders',
                'uri': localStorage.getItem('server') + '/api/v5/warehouse/orders/locations'
            }
        },
        GET_ONE: function (params) {
            const path = params.location_id + '/' + params.job_id;
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'Inventory Order for Location',
                'uri': localStorage.getItem('server') + '/api/v5/warehouse/orders/location/' + path
            }
        }
    },
    'OrderLocationSubmit': {
        GET_ONE: function (params) {
            const path = params.location_id + '/' + params.job_id;
            return {
                'method': 'GET',
                'uri': localStorage.getItem('server') + '/api/v5/warehouse/orders/approve/location/' + path
            }
        }
    },
    'OrderLocationDelete': {
        GET_ONE: function (params) {
            const path = params.location_id + '/' + params.job_id;
            return {
                'method': 'GET',
                'uri': localStorage.getItem('server') + '/api/v5/warehouse/orders/delete/location/' + path
            }
        }
    },
    'OrderLocationAdjustToAvailable': {
        GET_ONE: function (params) {
            const path = params.job_id + '/' + params.location_id;
            return {
                'method': 'GET',
                'uri': localStorage.getItem('server') + '/api/v5/warehouse/orders/adjust/to-available/' + path
            }
        }
    },
    'OrderLocationResetOverrides': {
        GET_ONE: function (params) {
            const path = params.job_id + '/' + params.location_id;
            return {
                'method': 'GET',
                'uri': localStorage.getItem('server') + '/api/v5/warehouse/orders/delete/override/' + path
            }
        }
    },
    'OrderProductEditCaseQty': {
        GET_ONE: function (params) {
            const path = params.job_id + '/' + params.location_id + '/' + params.product_id + '/' + params.qty;
            return {
                'method': 'GET',
                'uri': localStorage.getItem('server') + '/api/v5/warehouse/orders/override/' + path
            }
        }
    },
    'OrderProductSubmit': {
        GET_ONE: function (params) {
            const path = params.job_id + '/' + params.location_id + '/' + params.product_id;
            return {
                'method': 'GET',
                'uri': localStorage.getItem('server') + '/api/v5/warehouse/orders/approve/product/' + path
            }
        }
    },
    'OrderProductDelete': {
        GET_ONE: function (params) {
            const path = params.job_id + '/' + params.location_id + '/' + params.product_id;
            return {
                'method': 'GET',
                'uri': localStorage.getItem('server') + '/api/v5/warehouse/orders/delete/product/' + path
            }
        }
    }
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "InventoryOrders"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseInventoryOrdersResourceMap.js